<template>
    <div class="card">
        <header class="card-header">
            <router-link to="/cars/" class="card-header-title">
                Unissued invoices
            </router-link>
            <router-link to="/cars/" class="card-header-icon" aria-label="more options">
                  <span class="icon has-text-danger">
                      <i class="fas fa-file-invoice-dollar"></i>
                  </span>
            </router-link>
        </header>
        <div class="card-content">
            <chart :type="'pie'" :data="data" :options="options" style="height: 200px; width: auto;"></chart>
        </div>
    </div>
</template>

<script>
    import Chart from 'vue-bulma-chartjs'

    export default {
        components: {
            Chart
        },

        data () {
            return {
                data: {
                    labels: [
                        'Invoiced',
                        'Invoice unissued'
                    ],
                    datasets: [{
                        data: [10, 20],
                        backgroundColor: [
                            '#00d1b2',
                            '#ff3860'
                        ]
                    }],
                },
                options: {
                    legend: {
                        display: false
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .card {
        height: 255px;
    }
    .card-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 5px;
    }
    .total {
        font-size: 5rem;
        font-weight: 600;
    }
    /*
    chart js height 200px;
     */

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Manager/UnissuedInvoices.vue